module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.27393",
      "ably": "static-2.2",
      "conversations-async-data": "static-2.7119",
      "conversations-error-reporting": "static-1.8361",
      "conversations-internal-pub-sub": "static-1.15458",
      "conversations-internal-schema": "static-1.12114",
      "conversations-message-history": "static-1.10947",
      "conversations-test-sdk": "static-1.9923",
      "conversations-visitor-experience-components": "static-1.20756",
      "head-dlb": "static-1.4465",
      "hs-promise-utils": "static-1.4960",
      "hs-test-utils": "static-1.7425",
      "hubspot-dlb": "static-2.1707",
      "HubStyleTokens": "static-2.10946",
      "I18n": "static-7.1467",
      "jasmine-immutable": "static-1.2408",
      "jasmine-runner": "static-1.5849",
      "quartz": "static-1.6249",
      "react-dlb": "static-1.64",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "transmute": "static-2.77",
      "urlinator": "static-1.3982",
      "viral-links-lib": "static-1.6374",
      "visitor-ui-component-library": "static-1.5592",
      "webpack-env": "static-1.54",
      "ably-hubspot-js": "static-2.4044",
      "atom": "static-1.4570",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4254",
      "conversations-infrastructure": "static-1.8402",
      "conversations-prop-types": "static-1.6856",
      "conversations-visibility-tools": "static-1.5214",
      "conversations-visitor-message-history": "static-1.19493",
      "cssUtils": "static-1.618",
      "enviro": "static-4.345",
      "flux-actions": "static-1.290",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.5499",
      "hubspot-url-utils": "static-1.3531",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9058",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.319",
      "raven": "static-3.5386",
      "react": "static-7.151",
      "react-aria": "static-1.44",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1.16079",
      "react-select-plus": "static-1.65",
      "react-utils": "static-2.4827",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize": "static-1.3845",
      "sanitize-text": "static-1.7593",
      "signup-constants": "static-1.17786",
      "styled-components": "static-2.64",
      "StyleGuideUI": "static-3.478",
      "usage-tracker": "static-1.6843",
      "usage-tracker-core": "static-1.6693",
      "usage-tracker-multi": "static-1.5257",
      "usage-tracker-public": "static-1.6654",
      "visitor-ui-component-library-icons": "static-1.5403",
      "hs-promise-rejection-tracking": "static-1.4918",
      "raven-hubspot": "static-1.5693",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.2953",
      "moment": "static-3.26",
      "quartz-core": "static-1.5468",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4295",
      "foundations-components": "static-1.6970",
      "foundations-theming": "static-1.3785",
      "UIComponents": "static-3.7893",
      "cv-backend-services": "static-1.1375",
      "immutable-less": "static-1.3995",
      "conversations-skeleton-state": "static-1.6780",
      "crm-events-viz-core": "static-1.31578",
      "icons": "static-2.599",
      "react-input-autosize": "static-2.17",
      "rpc-client-utils": "static-1.4130",
      "tanstack-virtual": "static-1.19",
      "ui-images": "static-2.980",
      "permission-components": "static-1.4794",
      "react-virtualized": "static-2.86",
      "HeadJS": "static-2.634",
      "framer-motion": "static-1.57",
      "hs-test-utils-bend-plugin": "static-1.2536",
      "msw": "static-1.39",
      "testing-library": "static-1.139",
      "i18n-data": "static-1.211",
      "moment-timezone": "static-5.72",
      "jasmine": "static-4.3729",
      "quartz-config": "static-1.27",
      "quartz-core-utils": "static-1.3116",
      "signup-ui-url-generator": "static-2.7517",
      "HubStyle": "static-2.11254",
      "sassPrefix": "static-1.145",
      "csstype": "static-1.50",
      "quick-fetch": "static-1.3464",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.5260",
      "bender-build-tools": "static-1.2592",
      "dispatcher": "static-1.125",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.711",
      "hub-http-shared-msw-handlers": "static-1.8679",
      "hubspotter-http": "static-1.4065",
      "hubspotter-http-shared-msw-handlers": "static-1.8677",
      "mobile-manifest-mixins": "static-1.407",
      "platform-navigation-bootstrap": "static-1.11992",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.335",
      "hs-story-utils": "static-1.8805",
      "bend-plugin-foundations-components": "static-1.3239",
      "floating-ui": "static-1.45",
      "foundations-theming-specialty": "static-1.1501",
      "tanstack-table": "static-1.23",
      "bend-plugin-foundations-theming": "static-1.2268",
      "foundations-theming-base": "static-1.2770",
      "ts-schema": "static-1.3598",
      "apollo-stack-hubspot": "static-3.69",
      "avatar-components": "static-1.1934",
      "content-assistance-lib": "static-1.7082",
      "crm-component-utils": "static-1.37713",
      "crm-display-components": "static-1.23463",
      "crm-fe-perf": "static-1.22407",
      "crm-links": "static-1.5654",
      "crm-message-bus": "static-1.41562",
      "crm-search-service-types": "static-1.695",
      "crm-source-interpretation-lib": "static-1.4741",
      "customer-data-communicator": "static-1.44104",
      "customer-data-email": "static-1.17063",
      "customer-data-filters-ui": "static-1.37860",
      "customer-data-objects": "static-1.7091",
      "customer-data-objects-ui-components": "static-1.12443",
      "customer-data-properties": "static-1.49869",
      "customer-data-rte": "static-1.31733",
      "customer-data-ui-utilities": "static-1.9206",
      "data-fetching-client": "static-1.9114",
      "draft-plugins": "static-2.20718",
      "file-manager-components": "static-1.22032",
      "FileManagerCore": "static-1.37531",
      "frontend-preferences-client": "static-1.7386",
      "hubspot-apollo-client": "static-1.4260",
      "hubspot-prosemirror": "static-1.16797",
      "object-comments-thread-lib": "static-1.9325",
      "reference-resolvers-lite": "static-1.7515",
      "ui-addon-upgrades": "static-9.17094",
      "universal-associations-select": "static-1.10391",
      "platform-infra-nav-components": "static-1.7200",
      "graphql": "static-1.71",
      "ai-components-ui-library": "static-1.7536",
      "superstore": "static-1.4160",
      "ui-addon-video-player": "static-1.8196",
      "ui-coaching-tips": "static-1.27070",
      "card-properties-lib": "static-1.42698",
      "crm-actions": "static-1.5655",
      "crm-cards-data": "static-1.540",
      "crm-cards-sdk": "static-1.42043",
      "customer-data-properties-shared-msw-handlers": "static-1.8006",
      "customer-data-property-utils": "static-1.7431",
      "customer-data-tracking": "static-1.6307",
      "framework-data-schema-resolvers": "static-1.6308",
      "usage-tracker-container": "static-1.6833",
      "framework-data-table": "static-2.10712",
      "location-customization-utils-lib": "static-1.7645",
      "calling-error-reporting": "static-1.30784",
      "calling-internal-common": "static-1.30778",
      "calling-usage-tracker": "static-1.5949",
      "crm_data": "static-4.90318",
      "crm_schema": "static-3.90357",
      "crm-legacy-global-containers": "static-1.23227",
      "customer-data-content": "static-1.26231",
      "draft-content-plugins": "static-1.27110",
      "draft-convert": "static-2.31",
      "draft-email-branding-plugin": "static-2.23098",
      "draft-extend": "static-2.46",
      "draft-js": "static-5.37",
      "draft-signature-plugin": "static-1.22805",
      "EmailSignatureEditor": "static-1.23329",
      "FileManagerLib": "static-1.37672",
      "hubspot-prosemirror-plugins": "static-1.16789",
      "integration-settings-components": "static-1.13826",
      "integrations-lib": "static-1.14552",
      "integrations-tracking-lib": "static-1.5093",
      "native-integrations-shared-strings": "static-1.7245",
      "nav-meta": "static-1.28113",
      "outreach-assistant-email-generation": "static-1.5197",
      "property-translator": "static-1.4800",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.36237",
      "react-colorpicker": "static-2.9679",
      "react-dnd-compat": "static-1.4091",
      "react-immutable-render-mixin": "static-1.9",
      "reference-resolvers": "static-1.7640",
      "rich-text-lib": "static-1.18847",
      "sales-email-signature-service-client": "static-1.3364",
      "sequences-lib": "static-1.7233",
      "timezone-utils": "static-2.4631",
      "ui-addon-i18n": "static-1.10452",
      "ui-addon-iframeable": "static-1.8362",
      "ui-business-units-lib": "static-1.8375",
      "ui-gdpr-components": "static-1.9687",
      "ui-shepherd-react": "static-3.9507",
      "user-context": "static-1.4603",
      "whatsapp-sending-lib": "static-1.4118",
      "apollo-dlb": "static-3.73",
      "apollo-link-hub-http": "static-2.4169",
      "salesImages": "static-1.514",
      "customer-data-filters-ui-msw-helpers": "static-1.20294",
      "customer-data-reference-ui-components": "static-1.12531",
      "FormUrlGenerator": "static-2.4148",
      "framework-builder-read-service-client": "static-1.3505",
      "framework-data-schema-quick-fetch": "static-1.6213",
      "inbound-db-meta-service-client": "static-1.3217",
      "inbound-db-properties-service-client": "static-1.3441",
      "lodash": "static-4.7",
      "multi-account-reference-resolvers": "static-1.473",
      "onboarding-tours": "static-1.15860",
      "reporting-datasets-permissions-lib": "static-1.12116",
      "SharedI18nStrings": "static-1.175",
      "ui-addon-teams": "static-1.20814",
      "calling-global-api": "static-1.62686",
      "calling-lifecycle-internal": "static-1.64068",
      "calling-lifecycle-messages": "static-1.56362",
      "commerce-products-lib": "static-1.7953",
      "conditional-properties-service-client": "static-1.3377",
      "external-options-client-types": "static-1.3597",
      "google-libphonenumber": "static-1.26",
      "inbounddb-objects-service-types": "static-1.3684",
      "multi-currency-client-types": "static-1.3214",
      "object-builder-ui-client": "static-1.47014",
      "pipeline-validation-client-types": "static-1.3396",
      "property-value-citations": "static-1.483",
      "smart-property-lib": "static-1.4792",
      "tiered-pricing": "static-1.376",
      "ui-addon-form-validation": "static-1.10466",
      "directed-graph": "static-1.357",
      "event-emitter": "static-1.417",
      "fast-json-stable-stringify": "static-1.4",
      "immerable": "static-1.3549",
      "video-components-external": "static-1.9757",
      "video-data-lib": "static-1.33415",
      "audio-components": "static-1.5249",
      "cropperjs": "static-1.10",
      "FileManagerImages": "static-1.35183",
      "video-components": "static-1.11760",
      "video-embed": "static-1.34249",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.23881",
      "knowledge-content-types": "static-1.8060",
      "payment-link-components": "static-1.22180",
      "ui-addon-emoji-picker": "static-1.9371",
      "call-summary": "static-1.37377",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.8825",
      "batch-promise": "static-1.1014",
      "feature-store-service-types": "static-1.4079",
      "growth-monetization-service-types": "static-1.4086",
      "merchandise-lib": "static-1.245",
      "self-service-api": "static-1.9687",
      "upgrade-management-service-types": "static-1.4070",
      "chatspot-client-types": "static-1.10138",
      "chatspot-core": "static-1.19245",
      "ContentUtils": "static-1.66743",
      "copilot-toolkit": "static-1.9698",
      "growth-onboarding-feedback-components": "static-1.5919",
      "customer-data-sidebar": "static-2.44572",
      "enrichment-properties-lib": "static-1.13910",
      "persist-promise": "static-1.3172",
      "crm-pipelines-api-client-types": "static-1.3558",
      "customer-data-associations": "static-1.6693",
      "deal-intel-decorators": "static-1.326",
      "reporting-data": "static-1.65344",
      "ui-addon-draggable": "static-3.4278",
      "crm-record-cards-service-types": "static-1.3145",
      "crm_universal": "static-1.21256",
      "SalesContentIndexUI": "static-3.8300",
      "signup-ui-lego-core": "static-1.19796",
      "content-embed-lib": "static-1.6812",
      "data-model-builder-lib": "static-1.10588",
      "remote-ui": "static-1.54",
      "ui-components-test-utils": "static-1.5084",
      "ui-extensions-remote-renderer": "static-1.15695",
      "universal-page-editor-lib": "static-1.2487",
      "integrations-error-boundary-lib": "static-1.11967",
      "laboratory-lib": "static-3.6607",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.9903",
      "rxjs": "static-5.10",
      "ui-universal-auth": "static-1.8321",
      "messaging-types-lib": "static-1.44416",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "data-token-picker": "static-1.15515",
      "sequences-client-types-lib": "static-1.7090",
      "foundations-components-test-utils": "static-1.4454",
      "magpie-lib": "static-1.5067",
      "navigation-messaging": "static-1.5803",
      "getting-started-shared-tasks": "static-1.17062",
      "getting-started-shared-tasks-store": "static-1.16180",
      "whatsapp-management-lib": "static-1.7277",
      "growth-data-modal": "static-1.4732",
      "growth-onboarding-confetti": "static-1.2499",
      "growth-onboarding-next-action-utils": "static-1.888",
      "navigation-components": "static-1.16476",
      "ui-shepherd-tracker": "static-1.6888",
      "shared-worker-versioning": "static-1.10507",
      "calling-orchestration-shared-library": "static-1.33886",
      "onboarding-scopes": "static-1.5955",
      "products-iframe-lib": "static-1.6506",
      "products-ui-components-shared-msw-handlers": "static-1.9061",
      "breeze-intelligence-kit": "static-1.4816",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.8762",
      "fsm": "static-1.3139",
      "policy-lib": "static-1.6198",
      "react-tinymce": "static-1.53785",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.52911",
      "tinymce-plugins": "static-1.56025",
      "tinymce-themes": "static-1.54881",
      "content-media-composition-data-lib": "static-1.10102",
      "content-media-compositions": "static-2.14109",
      "idb-keyval": "static-1.33",
      "magpie-types": "static-1.4527",
      "media-bridge-lib": "static-1.18072",
      "content-icons-ui": "static-1.2033",
      "social-insights-client-types": "static-1.20608",
      "outpost": "static-1.3727",
      "commerce-analytics-service-client": "static-1.3099",
      "ui-addon-opt": "static-4.7924",
      "commerce-tours-lib": "static-1.5218",
      "growth-onboarding-reliability": "static-1.4551",
      "sales-checkout-service-client": "static-1.3111",
      "ai-addon-copilot-preview": "static-1.6748",
      "calling-cross-tab-library": "static-1.18747",
      "wootric-nps": "static-1.6353",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4166",
      "underscore": "static-1.8",
      "simple-logging-lib": "static-1.2415",
      "card-payment-highlight-lib": "static-1.35702",
      "card-subscription-highlight-lib": "static-1.38081",
      "commerce-billing-lib": "static-1.17650",
      "commerce-contract-lib": "static-1.10229",
      "crm_components": "static-3.90318",
      "invoices-highlight-card-lib": "static-1.53087",
      "orders-highlight-card-lib": "static-1.20222",
      "products-highlight-card-lib": "static-1.16237",
      "project-storage": "static-1.4103",
      "quotes-highlight-card-lib": "static-1.70151",
      "usage-based-billing-components-lib": "static-1.7232",
      "deal-intel-utils": "static-1.330",
      "reporting-client-types": "static-1.2265",
      "react-flip-move": "static-1.59",
      "FireAlarmUi": "static-1.4079",
      "sales-templates-service-types-lib": "static-1.3669",
      "ui-asset-management-lib": "static-1.10187",
      "emoji-regex": "static-1.7",
      "association-settings-lib": "static-1.8801",
      "collaboration-sidebar": "static-1.56440",
      "data-model-commons-lib": "static-1.11154",
      "feedback-loader": "static-1.28196",
      "final-form": "static-1.58",
      "html-to-image": "static-1.42",
      "object-definition-builder-lib": "static-1.6476",
      "property-management-iframe": "static-1.11258",
      "reactflow": "static-1.49",
      "used-in-list-lib": "static-1.6331",
      "visual-association": "static-1.5277",
      "highcharts": "static-8.93",
      "reporting-visualizations": "static-1.57421",
      "ui-extensibility-client-types": "static-1.3455",
      "automation-platform-service-types": "static-1.2350",
      "ContentData": "static-1.66818",
      "email-portal-health-service-types": "static-1.453",
      "marketing-email-service-types": "static-1.1636",
      "reactive-lib": "static-1.173",
      "purchase-motions-components": "static-1.4955",
      "short-messages-app-service-client": "static-1.3483",
      "ui-tool-access": "static-1.9513",
      "calling-orchestration-schema": "static-1.34111",
      "sales-views-client-types": "static-1.3700",
      "trellis-story-utils": "static-1.3985",
      "storybook-react": "static-1.20",
      "hub-http-contrib": "static-1.2541",
      "interframe": "static-3.4190",
      "tinymce-data": "static-1.38996",
      "ui-addon-sales-email": "static-1.4671",
      "codemirror": "static-5.84",
      "layout-dnd-components": "static-1.11476",
      "layout-dnd-utils": "static-1.10451",
      "react-codemirror": "static-1.10063",
      "ui-brand-identity-lib": "static-1.12563",
      "NamespacedHubStyle": "static-2.8660",
      "hls.js": "static-1.28",
      "js-cookie": "static-1.18",
      "onboarding-tours-client": "static-1.4074",
      "ai-rendering-library": "static-1.8400",
      "ai-settings-ui-library": "static-1.6856",
      "chirp-fetch": "static-1.1415",
      "copilot-plugins": "static-1.9671",
      "commerce-shared-components-lib": "static-1.17082",
      "commerce-subscription-lib": "static-1.35658",
      "commerce-tools-ui-lib": "static-1.9114",
      "usage-tracker-session-replay": "static-1.4529",
      "utility-belt": "static-1.1921",
      "payments-enrollment-embed-lib": "static-1.20968",
      "quotes-ui-lib": "static-1.78868",
      "zustand": "static-1.51",
      "accounting-integrations-ui-components": "static-1.6136",
      "invoices-ui-lib": "static-1.53103",
      "commerce-products-api": "static-1.1407",
      "SafeStorage": "static-1.3791",
      "invoices-iframe-lib": "static-1.55161",
      "quotes-modal-lib": "static-1.100825",
      "reporting-ui-components": "static-2.62618",
      "subscription-experience-data-types": "static-1.14049",
      "association-translator": "static-1.2584",
      "crm-settings-header-lib": "static-1.7686",
      "settings-ui-nav": "static-2.9591",
      "chatspot-widget-iframe": "static-1.19237",
      "collaboration-sidebar-common": "static-1.1236",
      "property-management-common": "static-1.3545",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.14293",
      "advanced-menus-lib": "static-1.11331",
      "ExportDialog": "static-6.9903",
      "ui-memberships-settings-lib": "static-1.32560",
      "nav-client-types": "static-1.1708",
      "purchase-motions-api": "static-1.4957",
      "trials-service-types": "static-1.3487",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.8776",
      "browser-eslint": "static-2.57",
      "highlight.js": "static-1.68",
      "reporting-action-components": "static-1.39867",
      "ui-addon-react-router-dom": "static-1.9024",
      "growth-onboarding-empty-states": "static-1.4962",
      "InboxConnectUtils": "static-4.13448",
      "payments-post-enroll-local-storage-lib": "static-1.4483",
      "qrcode-generator": "static-1.57",
      "amplitude-session-replay-browser": "static-1.49",
      "marketplace-ui-apps-core": "static-1.16659",
      "stripe-embedded-components": "static-1.6624",
      "products-ui-components": "static-1.38472",
      "totals-ui-components": "static-1.22154",
      "reporting-plugins": "static-1.9471",
      "reporting-reports": "static-1.65024",
      "reporting-snowflake": "static-1.53964",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.14292",
      "simple-menus-lib": "static-1.15809",
      "eligibility-engine-service-types": "static-1.2768",
      "dashboard-lib": "static-1.79482",
      "share-with-third-party-component-lib": "static-1.8140",
      "developer-experience-shared-components": "static-1.9836",
      "marketplace-ui-client-types": "static-1.15532",
      "marketplace-ui-common": "static-1.18125",
      "ui-addon-integrations-directory-panel": "static-2.7472",
      "stripe-connect-js": "static-1.43",
      "property-description-translator": "static-1.3250",
      "commerce-totals-service-types": "static-1.3323",
      "campaign-roi-lib": "static-1.7384",
      "redux-actions": "static-3.7",
      "apps-service-types": "static-1.3416",
      "oauth-service-types": "static-1.3672",
      "react-window": "static-1.13"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.27393",
      "ably": "/ably/static-2.2",
      "conversations-async-data": "/conversations-async-data/static-2.7119",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8361",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15458",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12114",
      "conversations-message-history": "/conversations-message-history/static-1.10947",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.9923",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.20756",
      "head-dlb": "/head-dlb/static-1.4465",
      "hs-promise-utils": "/hs-promise-utils/static-1.4960",
      "hs-test-utils": "/hs-test-utils/static-1.7425",
      "hubspot-dlb": "/hubspot-dlb/static-2.1707",
      "HubStyleTokens": "/HubStyleTokens/static-2.10946",
      "I18n": "/I18n/static-7.1467",
      "jasmine-immutable": "/jasmine-immutable/static-1.2408",
      "jasmine-runner": "/jasmine-runner/static-1.5849",
      "quartz": "/quartz/static-1.6249",
      "react-dlb": "/react-dlb/static-1.64",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "transmute": "/transmute/static-2.77",
      "urlinator": "/urlinator/static-1.3982",
      "viral-links-lib": "/viral-links-lib/static-1.6374",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5592",
      "webpack-env": "/webpack-env/static-1.54",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4044",
      "atom": "/atom/static-1.4570",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4254",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.8402",
      "conversations-prop-types": "/conversations-prop-types/static-1.6856",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.5214",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.19493",
      "cssUtils": "/cssUtils/static-1.618",
      "enviro": "/enviro/static-4.345",
      "flux-actions": "/flux-actions/static-1.290",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.5499",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3531",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9058",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.319",
      "raven": "/raven/static-3.5386",
      "react": "/react/static-7.151",
      "react-aria": "/react-aria/static-1.44",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1.16079",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-utils": "/react-utils/static-2.4827",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize": "/sanitize/static-1.3845",
      "sanitize-text": "/sanitize-text/static-1.7593",
      "signup-constants": "/signup-constants/static-1.17786",
      "styled-components": "/styled-components/static-2.64",
      "StyleGuideUI": "/StyleGuideUI/static-3.478",
      "usage-tracker": "/usage-tracker/static-1.6843",
      "usage-tracker-core": "/usage-tracker-core/static-1.6693",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5257",
      "usage-tracker-public": "/usage-tracker-public/static-1.6654",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5403",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4918",
      "raven-hubspot": "/raven-hubspot/static-1.5693",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2953",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.5468",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4295",
      "foundations-components": "/foundations-components/static-1.6970",
      "foundations-theming": "/foundations-theming/static-1.3785",
      "UIComponents": "/UIComponents/static-3.7893",
      "cv-backend-services": "/cv-backend-services/static-1.1375",
      "immutable-less": "/immutable-less/static-1.3995",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6780",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.31578",
      "icons": "/icons/static-2.599",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "rpc-client-utils": "/rpc-client-utils/static-1.4130",
      "tanstack-virtual": "/tanstack-virtual/static-1.19",
      "ui-images": "/ui-images/static-2.980",
      "permission-components": "/permission-components/static-1.4794",
      "react-virtualized": "/react-virtualized/static-2.86",
      "HeadJS": "/HeadJS/static-2.634",
      "framer-motion": "/framer-motion/static-1.57",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2536",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.139",
      "i18n-data": "/i18n-data/static-1.211",
      "moment-timezone": "/moment-timezone/static-5.72",
      "jasmine": "/jasmine/static-4.3729",
      "quartz-config": "/quartz-config/static-1.27",
      "quartz-core-utils": "/quartz-core-utils/static-1.3116",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7517",
      "HubStyle": "/HubStyle/static-2.11254",
      "sassPrefix": "/sassPrefix/static-1.145",
      "csstype": "/csstype/static-1.50",
      "quick-fetch": "/quick-fetch/static-1.3464",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5260",
      "bender-build-tools": "/bender-build-tools/static-1.2592",
      "dispatcher": "/dispatcher/static-1.125",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.711",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8679",
      "hubspotter-http": "/hubspotter-http/static-1.4065",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8677",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.407",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11992",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.335",
      "hs-story-utils": "/hs-story-utils/static-1.8805",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3239",
      "floating-ui": "/floating-ui/static-1.45",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1501",
      "tanstack-table": "/tanstack-table/static-1.23",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2268",
      "foundations-theming-base": "/foundations-theming-base/static-1.2770",
      "ts-schema": "/ts-schema/static-1.3598",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.69",
      "avatar-components": "/avatar-components/static-1.1934",
      "content-assistance-lib": "/content-assistance-lib/static-1.7082",
      "crm-component-utils": "/crm-component-utils/static-1.37713",
      "crm-display-components": "/crm-display-components/static-1.23463",
      "crm-fe-perf": "/crm-fe-perf/static-1.22407",
      "crm-links": "/crm-links/static-1.5654",
      "crm-message-bus": "/crm-message-bus/static-1.41562",
      "crm-search-service-types": "/crm-search-service-types/static-1.695",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.4741",
      "customer-data-communicator": "/customer-data-communicator/static-1.44104",
      "customer-data-email": "/customer-data-email/static-1.17063",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.37860",
      "customer-data-objects": "/customer-data-objects/static-1.7091",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12443",
      "customer-data-properties": "/customer-data-properties/static-1.49869",
      "customer-data-rte": "/customer-data-rte/static-1.31733",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9206",
      "data-fetching-client": "/data-fetching-client/static-1.9114",
      "draft-plugins": "/draft-plugins/static-2.20718",
      "file-manager-components": "/file-manager-components/static-1.22032",
      "FileManagerCore": "/FileManagerCore/static-1.37531",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7386",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4260",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.16797",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.9325",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7515",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17094",
      "universal-associations-select": "/universal-associations-select/static-1.10391",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7200",
      "graphql": "/graphql/static-1.71",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.7536",
      "superstore": "/superstore/static-1.4160",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8196",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.27070",
      "card-properties-lib": "/card-properties-lib/static-1.42698",
      "crm-actions": "/crm-actions/static-1.5655",
      "crm-cards-data": "/crm-cards-data/static-1.540",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.42043",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8006",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7431",
      "customer-data-tracking": "/customer-data-tracking/static-1.6307",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6308",
      "usage-tracker-container": "/usage-tracker-container/static-1.6833",
      "framework-data-table": "/framework-data-table/static-2.10712",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.7645",
      "calling-error-reporting": "/calling-error-reporting/static-1.30784",
      "calling-internal-common": "/calling-internal-common/static-1.30778",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.5949",
      "crm_data": "/crm_data/static-4.90318",
      "crm_schema": "/crm_schema/static-3.90357",
      "crm-legacy-global-containers": "/crm-legacy-global-containers/static-1.23227",
      "customer-data-content": "/customer-data-content/static-1.26231",
      "draft-content-plugins": "/draft-content-plugins/static-1.27110",
      "draft-convert": "/draft-convert/static-2.31",
      "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.23098",
      "draft-extend": "/draft-extend/static-2.46",
      "draft-js": "/draft-js/static-5.37",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.22805",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23329",
      "FileManagerLib": "/FileManagerLib/static-1.37672",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.16789",
      "integration-settings-components": "/integration-settings-components/static-1.13826",
      "integrations-lib": "/integrations-lib/static-1.14552",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5093",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7245",
      "nav-meta": "/nav-meta/static-1.28113",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.5197",
      "property-translator": "/property-translator/static-1.4800",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.36237",
      "react-colorpicker": "/react-colorpicker/static-2.9679",
      "react-dnd-compat": "/react-dnd-compat/static-1.4091",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "reference-resolvers": "/reference-resolvers/static-1.7640",
      "rich-text-lib": "/rich-text-lib/static-1.18847",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3364",
      "sequences-lib": "/sequences-lib/static-1.7233",
      "timezone-utils": "/timezone-utils/static-2.4631",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10452",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8362",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8375",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.9687",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9507",
      "user-context": "/user-context/static-1.4603",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.4118",
      "apollo-dlb": "/apollo-dlb/static-3.73",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4169",
      "salesImages": "/salesImages/static-1.514",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.20294",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12531",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4148",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3505",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6213",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3217",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3441",
      "lodash": "/lodash/static-4.7",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.473",
      "onboarding-tours": "/onboarding-tours/static-1.15860",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12116",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.175",
      "ui-addon-teams": "/ui-addon-teams/static-1.20814",
      "calling-global-api": "/calling-global-api/static-1.62686",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64068",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56362",
      "commerce-products-lib": "/commerce-products-lib/static-1.7953",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3377",
      "external-options-client-types": "/external-options-client-types/static-1.3597",
      "google-libphonenumber": "/google-libphonenumber/static-1.26",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3684",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3214",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.47014",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3396",
      "property-value-citations": "/property-value-citations/static-1.483",
      "smart-property-lib": "/smart-property-lib/static-1.4792",
      "tiered-pricing": "/tiered-pricing/static-1.376",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10466",
      "directed-graph": "/directed-graph/static-1.357",
      "event-emitter": "/event-emitter/static-1.417",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "immerable": "/immerable/static-1.3549",
      "video-components-external": "/video-components-external/static-1.9757",
      "video-data-lib": "/video-data-lib/static-1.33415",
      "audio-components": "/audio-components/static-1.5249",
      "cropperjs": "/cropperjs/static-1.10",
      "FileManagerImages": "/FileManagerImages/static-1.35183",
      "video-components": "/video-components/static-1.11760",
      "video-embed": "/video-embed/static-1.34249",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.23881",
      "knowledge-content-types": "/knowledge-content-types/static-1.8060",
      "payment-link-components": "/payment-link-components/static-1.22180",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9371",
      "call-summary": "/call-summary/static-1.37377",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.8825",
      "batch-promise": "/batch-promise/static-1.1014",
      "feature-store-service-types": "/feature-store-service-types/static-1.4079",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4086",
      "merchandise-lib": "/merchandise-lib/static-1.245",
      "self-service-api": "/self-service-api/static-1.9687",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4070",
      "chatspot-client-types": "/chatspot-client-types/static-1.10138",
      "chatspot-core": "/chatspot-core/static-1.19245",
      "ContentUtils": "/ContentUtils/static-1.66743",
      "copilot-toolkit": "/copilot-toolkit/static-1.9698",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.5919",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.44572",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.13910",
      "persist-promise": "/persist-promise/static-1.3172",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3558",
      "customer-data-associations": "/customer-data-associations/static-1.6693",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.326",
      "reporting-data": "/reporting-data/static-1.65344",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4278",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3145",
      "crm_universal": "/crm_universal/static-1.21256",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8300",
      "signup-ui-lego-core": "/signup-ui-lego-core/static-1.19796",
      "content-embed-lib": "/content-embed-lib/static-1.6812",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.10588",
      "remote-ui": "/remote-ui/static-1.54",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5084",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.15695",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2487",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.11967",
      "laboratory-lib": "/laboratory-lib/static-3.6607",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.9903",
      "rxjs": "/rxjs/static-5.10",
      "ui-universal-auth": "/ui-universal-auth/static-1.8321",
      "messaging-types-lib": "/messaging-types-lib/static-1.44416",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "data-token-picker": "/data-token-picker/static-1.15515",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7090",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4454",
      "magpie-lib": "/magpie-lib/static-1.5067",
      "navigation-messaging": "/navigation-messaging/static-1.5803",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17062",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16180",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.7277",
      "growth-data-modal": "/growth-data-modal/static-1.4732",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2499",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.888",
      "navigation-components": "/navigation-components/static-1.16476",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6888",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10507",
      "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.33886",
      "onboarding-scopes": "/onboarding-scopes/static-1.5955",
      "products-iframe-lib": "/products-iframe-lib/static-1.6506",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9061",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.4816",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.8762",
      "fsm": "/fsm/static-1.3139",
      "policy-lib": "/policy-lib/static-1.6198",
      "react-tinymce": "/react-tinymce/static-1.53785",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.52911",
      "tinymce-plugins": "/tinymce-plugins/static-1.56025",
      "tinymce-themes": "/tinymce-themes/static-1.54881",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.10102",
      "content-media-compositions": "/content-media-compositions/static-2.14109",
      "idb-keyval": "/idb-keyval/static-1.33",
      "magpie-types": "/magpie-types/static-1.4527",
      "media-bridge-lib": "/media-bridge-lib/static-1.18072",
      "content-icons-ui": "/content-icons-ui/static-1.2033",
      "social-insights-client-types": "/social-insights-client-types/static-1.20608",
      "outpost": "/outpost/static-1.3727",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3099",
      "ui-addon-opt": "/ui-addon-opt/static-4.7924",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5218",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4551",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3111",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.6748",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.18747",
      "wootric-nps": "/wootric-nps/static-1.6353",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4166",
      "underscore": "/underscore/static-1.8",
      "simple-logging-lib": "/simple-logging-lib/static-1.2415",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.35702",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38081",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.17650",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.10229",
      "crm_components": "/crm_components/static-3.90318",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53087",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20222",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.16237",
      "project-storage": "/project-storage/static-1.4103",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.70151",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7232",
      "deal-intel-utils": "/deal-intel-utils/static-1.330",
      "reporting-client-types": "/reporting-client-types/static-1.2265",
      "react-flip-move": "/react-flip-move/static-1.59",
      "FireAlarmUi": "/FireAlarmUi/static-1.4079",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3669",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10187",
      "emoji-regex": "/emoji-regex/static-1.7",
      "association-settings-lib": "/association-settings-lib/static-1.8801",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.56440",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.11154",
      "feedback-loader": "/feedback-loader/static-1.28196",
      "final-form": "/final-form/static-1.58",
      "html-to-image": "/html-to-image/static-1.42",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.6476",
      "property-management-iframe": "/property-management-iframe/static-1.11258",
      "reactflow": "/reactflow/static-1.49",
      "used-in-list-lib": "/used-in-list-lib/static-1.6331",
      "visual-association": "/visual-association/static-1.5277",
      "highcharts": "/highcharts/static-8.93",
      "reporting-visualizations": "/reporting-visualizations/static-1.57421",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3455",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2350",
      "ContentData": "/ContentData/static-1.66818",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.453",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1636",
      "reactive-lib": "/reactive-lib/static-1.173",
      "purchase-motions-components": "/purchase-motions-components/static-1.4955",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3483",
      "ui-tool-access": "/ui-tool-access/static-1.9513",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34111",
      "sales-views-client-types": "/sales-views-client-types/static-1.3700",
      "trellis-story-utils": "/trellis-story-utils/static-1.3985",
      "storybook-react": "/storybook-react/static-1.20",
      "hub-http-contrib": "/hub-http-contrib/static-1.2541",
      "interframe": "/interframe/static-3.4190",
      "tinymce-data": "/tinymce-data/static-1.38996",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4671",
      "codemirror": "/codemirror/static-5.84",
      "layout-dnd-components": "/layout-dnd-components/static-1.11476",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.10451",
      "react-codemirror": "/react-codemirror/static-1.10063",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.12563",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8660",
      "hls.js": "/hls.js/static-1.28",
      "js-cookie": "/js-cookie/static-1.18",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4074",
      "ai-rendering-library": "/ai-rendering-library/static-1.8400",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.6856",
      "chirp-fetch": "/chirp-fetch/static-1.1415",
      "copilot-plugins": "/copilot-plugins/static-1.9671",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17082",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.35658",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9114",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4529",
      "utility-belt": "/utility-belt/static-1.1921",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.20968",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.78868",
      "zustand": "/zustand/static-1.51",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6136",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.53103",
      "commerce-products-api": "/commerce-products-api/static-1.1407",
      "SafeStorage": "/SafeStorage/static-1.3791",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.55161",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.100825",
      "reporting-ui-components": "/reporting-ui-components/static-2.62618",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14049",
      "association-translator": "/association-translator/static-1.2584",
      "crm-settings-header-lib": "/crm-settings-header-lib/static-1.7686",
      "settings-ui-nav": "/settings-ui-nav/static-2.9591",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.19237",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.1236",
      "property-management-common": "/property-management-common/static-1.3545",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.14293",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11331",
      "ExportDialog": "/ExportDialog/static-6.9903",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.32560",
      "nav-client-types": "/nav-client-types/static-1.1708",
      "purchase-motions-api": "/purchase-motions-api/static-1.4957",
      "trials-service-types": "/trials-service-types/static-1.3487",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.8776",
      "browser-eslint": "/browser-eslint/static-2.57",
      "highlight.js": "/highlight.js/static-1.68",
      "reporting-action-components": "/reporting-action-components/static-1.39867",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9024",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.4962",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.13448",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4483",
      "qrcode-generator": "/qrcode-generator/static-1.57",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.49",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.16659",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.6624",
      "products-ui-components": "/products-ui-components/static-1.38472",
      "totals-ui-components": "/totals-ui-components/static-1.22154",
      "reporting-plugins": "/reporting-plugins/static-1.9471",
      "reporting-reports": "/reporting-reports/static-1.65024",
      "reporting-snowflake": "/reporting-snowflake/static-1.53964",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.14292",
      "simple-menus-lib": "/simple-menus-lib/static-1.15809",
      "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2768",
      "dashboard-lib": "/dashboard-lib/static-1.79482",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8140",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.9836",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.15532",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.18125",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7472",
      "stripe-connect-js": "/stripe-connect-js/static-1.43",
      "property-description-translator": "/property-description-translator/static-1.3250",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3323",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.7384",
      "redux-actions": "/redux-actions/static-3.7",
      "apps-service-types": "/apps-service-types/static-1.3416",
      "oauth-service-types": "/oauth-service-types/static-1.3672",
      "react-window": "/react-window/static-1.13"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};